import { render, staticRenderFns } from "./feedbackView.vue?vue&type=template&id=1f0671e2"
import script from "./feedbackView.vue?vue&type=script&lang=js"
export * from "./feedbackView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports